import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as selectors from './../test-overview/selectors';
import * as actions from './actions';
import { TESTS_BY_ERROR_LIMIT } from '../../constants';
import * as generalActions from './../general/actions';
import * as generalSelectors from './../general/selectors';
import { clearAndGetFilters, setInitialFilters } from './../filters/operations';
import { getTrends, getPastTrends } from '../test-overview/operations';

import { operations } from './index';

export const getAggregatedTestErrors = (payload) => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), payload);
  return dispatch(actions.getAggregatedTestErrors(params));
};

export const getTestsByError = (payload) => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), payload);

  return dispatch(actions.getTestsByError({
    ...params,
    size: TESTS_BY_ERROR_LIMIT,
    error: payload.error,
  }, { errorName: payload.error }))
    .catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message,
        'We\'ve experienced an issue while loading test errors.',
      ));
    });
};

export const loadErrors = () => (dispatch) => Promise.all([
  dispatch(getTrends()),
  dispatch(getPastTrends()),
  dispatch(operations.getAggregatedTestErrors()),
]).catch((error) => {
  dispatch(notificationActions.notifyDanger(
    error.message, 'We\'ve experienced an issue loading test error data.', true,
  ));
});

export const clearFilters = (location) => (dispatch) => Promise.all([
  dispatch(clearAndGetFilters(null, { location })),
  dispatch(operations.loadErrors()),
]);

export const loadInitData = () => (dispatch, getState) => (
  dispatch(generalActions.loadInitData(
    Promise.all([
      dispatch(clearAndGetFilters()),
      dispatch(setInitialFilters(...generalSelectors.initialFilterSelector(getState()))),
    ]).then(() => {
      dispatch(loadErrors());
    }).catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message, 'We\'ve experienced an issue while loading data.', true,
      ));
    }),
  ))
);
